export default __webpack_public_path__ + "static/media/Board Level Committees and their members.efcac619.pdf";